import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { fetchIAMAvailableModulesRequestSaga, resetAvailableModules } from 'domains/catalog/CatalogIam.store';
import { getUserRights, UserRole } from 'domains/user';
import { getData, hasUserAnyRight } from 'utils';

export const useFetchIAMAvailableModules = (catalogVehicle?: VehicleDetail): void => {
  const dispatch = useDispatch();
  const userRights = getData(useSelector(getUserRights));
  const userRightsRef = useRef(userRights);
  userRightsRef.current = userRights;

  useEffect(() => {
    // do not fetch for R3_MOTRIO here, ask later after selecting tab
    if (catalogVehicle?.iamVehicle?.versionCode && !hasUserAnyRight([UserRole.R3_MOTRIO], userRightsRef.current)) {
      dispatch(fetchIAMAvailableModulesRequestSaga());
    }
    return () => {
      dispatch(resetAvailableModules());
    };
  }, [dispatch, catalogVehicle]);
};
